module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Public Administration-99a9ab0aac682fe4ef8bd7cfe06ad8b4.png";